<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="name">Район</label>
    <input
      type="text"
      class="form-control"
      id="name"
      placeholder="Введите район"
      v-bind:value="value"
      v-on:input="updateValue($event.target.value)"
    >
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'district-name-field',
  props: {
    value: String,
    error: Array
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// DistrictName.vue?2467d5f4